import { gql } from '@apollo/client';

export const GET_COLLECTIONS_LIST = gql`
  query GetCollectionsList($first: Int, $after: String) {
    currentUser {
      id
      bookmarkCollections(first: $first, after: $after) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          id
          name
          photos {
            url
          }
          ads {
            totalCount
            pageInfo {
              endCursor
              hasNextPage
            }
            nodes {
              id
              legacyResourceId
              status
            }
          }
        }
      }
    }
  }
`;

export const GET_USER_FAVORITES = gql`
  query GetUserFavorites {
    currentUser {
      id
      bookmarks(first: 1) {
        nodes {
          id
          legacyResourceId
          photo {
            url
          }
        }
        totalCount
      }
      bookmarkedCategories {
        bookmarkedAdsCount
        category {
          id
          name
        }
      }
      bookmarkCollections {
        nodes {
          id
          name
          ads {
            totalCount
            pageInfo {
              endCursor
              hasNextPage
            }
            nodes {
              id
              status
              legacyResourceId
              photo {
                url
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_COLLECTION_DATA = gql`
  query GetCollectionData($id: ID!, $first: Int, $after: String) {
    bookmarkCollectionDetails(bookmarkCollectionId: $id) {
      id
      name
      isOwner
      photos {
        url
      }
      ads(first: $first, after: $after) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          id
          title
          legacyResourceId
          updatedAt
          price
          status
          region
          kinds
          path
          photo {
            url
          }
          shop {
            id
          }
        }
      }
    }
  }
`;
